export const contentTypes = {
    FETCH_REQUEST: 'CONTENT_FETCH_REQUEST',
    FETCH_SUCCESS: 'CONTENT_FETCH_SUCCESS',
    FETCH_FAILURE: 'CONTENT_FETCH_FAILURE',
}